import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface NavItem {
  to: string;
  icon: string;
  label: string;
}

const contentItems: NavItem[] = [
  { to: '/admin/hero', icon: '🏠', label: 'Hero Section' },
  { to: '/admin/about', icon: '👤', label: 'About' },
  { to: '/admin/music', icon: '🎵', label: 'Music' },
  { to: '/admin/services', icon: '💼', label: 'Services' },
  { to: '/admin/contact', icon: '📧', label: 'Contact' },
  { to: '/admin/announcement', icon: '📢', label: 'Announcement' },
  { to: '/admin/beats', icon: '🎹', label: 'Beats Page' },
];

const collectionItems: NavItem[] = [
  { to: '/admin/albums', icon: '💿', label: 'Albums' },
  { to: '/admin/collaborators', icon: '🤝', label: 'Collaborators' },
  { to: '/admin/social-links', icon: '🔗', label: 'Social Links' },
  { to: '/admin/stats', icon: '📊', label: 'Stats' },
  { to: '/admin/releases', icon: '🎼', label: 'Releases' },
];

const systemItems: NavItem[] = [
  { to: '/admin/media', icon: '📁', label: 'Media Library' },
  { to: '/admin/settings', icon: '⚙️', label: 'Settings' },
];

const Sidebar: React.FC = () => {
  const { user, logout } = useAuth();

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-header">
        <NavLink to="/admin" className="admin-sidebar-logo">
          <span>andrxw</span> CMS
        </NavLink>
      </div>

      <nav className="admin-sidebar-nav">
        <div className="admin-nav-section">
          <div className="admin-nav-section-title">Dashboard</div>
          <NavLink
            to="/admin"
            end
            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
          >
            <span className="admin-nav-link-icon">📊</span>
            Overview
          </NavLink>
        </div>

        <div className="admin-nav-section">
          <div className="admin-nav-section-title">Content</div>
          {contentItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
            >
              <span className="admin-nav-link-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="admin-nav-section">
          <div className="admin-nav-section-title">Collections</div>
          {collectionItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
            >
              <span className="admin-nav-link-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="admin-nav-section">
          <div className="admin-nav-section-title">System</div>
          {systemItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
            >
              <span className="admin-nav-link-icon">{item.icon}</span>
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>

      <div className="admin-sidebar-footer">
        <div className="admin-user-info">
          <div className="admin-user-avatar">
            {user?.name?.charAt(0).toUpperCase() || 'A'}
          </div>
          <div className="admin-user-details">
            <div className="admin-user-name">{user?.name || 'Admin'}</div>
            <div className="admin-user-email">{user?.email || ''}</div>
          </div>
        </div>
        <button className="admin-btn admin-btn-secondary" style={{ width: '100%' }} onClick={logout}>
          Sign out
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
